import * as http from 'utils/http';

import moment from 'moment';

import objectize from './objectize';
import normalize from './normalize';
import urlToId from './urlToId';

let store = null;
export const init = (s) => {
  store = s;
};

export const arrayize = (obj /*, field = '_url'*/) => {
  // NOTICE: If we're not going to access the '_url' field this works
  //return Object.keys(obj || {}).map(key => ({ ...obj[key], [field]: key }));
  return Object.values(obj || {});
};

export const booleanize = (thing) => {
  // TODO: consider other cases that evaluate to false
  return !!thing && thing !== 'false';
};

export const jsonize = (response) => {
  if (!response) {
    return Promise.reject({ code: 400, text: 'Bad Request', response });
  }

  if (!response.ok) {
    return Promise.reject({ code: response.status, text: response.statusText, response });
  }
  return response.json().catch(() => ({}));
};

export const blob = (response) => {
  if (!response) {
    return Promise.reject({ code: 400, text: 'Bad Request', response });
  }

  if (!response.ok) {
    return Promise.reject({ code: response.status, text: response.statusText, response });
  }
  return response.blob().catch(() => ({}));
};

export const errorize = (error) => {
  return Promise.reject(error || 'Unknown error');
};

export const adaptFieldFromURL = (field, _singularField) => (obj) => {
  if (!store) return Promise.reject('utils/auth not initialized');

  if (!obj) {
    return Promise.resolve(obj);
  }

  if (typeof obj[field] === 'string') {
    // TODO: this is a basic case of convention over configuration.
    // Let's see if it works
    const state = store.getState()[field + 's'];

    // TO DELETE: old version adapting arrays
    if (state && state.constructor === Array) {
      const cachedResult = state.filter((o) => o.url && o.url === http.makeAbsoluteURL(obj[field]));
      if (cachedResult.length > 0) {
        return Promise.resolve(Object.assign({}, obj, { [field]: cachedResult[0] }));
      }
    }

    if (state && state.constructor === Object) {
      const cachedResult = state[http.makeAbsoluteURL(obj[field])];
      if (cachedResult) {
        return Promise.resolve(Object.assign({}, obj, { [field]: cachedResult }));
      }
    }

    return http
      .get(obj[field])
      .then((fieldObj) => Object.assign({}, obj, { [field]: fieldObj }))
      .catch(() => Object.assign({}, obj, { [field]: null }));
  } else if (Array.isArray(obj[field])) {
    // TODO: this is another case of convention over configuration.
    // Let's see if it works
    // Sometimes (e.g. `user_set`) we may need to specify the singular name
    const singularField = _singularField || field.replace(/s$/, '');

    return Promise.all(
      obj[field].map((subfield) =>
        adaptFieldFromURL(singularField)({ [singularField]: subfield }).then(
          (result) => result[singularField]
        )
      )
    ).then((results) => Object.assign({}, obj, { [field]: results }));
  } else {
    return Promise.resolve(obj);
  }
};

export const humanDateToComputedDate = (date) => {
  const today = moment();

  if (date === 'today') {
    return today.format('YYYY-MM-DD');
  } else if (date === 'yesterday') {
    return today.subtract(1, 'day').format('YYYY-MM-DD');
  } else if (date === 'tomorrow') {
    return today.add(1, 'day').format('YYYY-MM-DD');
  } else if (date) {
    return moment(date).format('YYYY-MM-DD');
  } else {
    return null;
  }
};

const valueOrUndefined = (label) => (value) => value ? { [label]: value } : null;

export const queryToFilters = (query = {}) => {
  const convert = {
    date(value) {
      const delivered_or_cancelled_at = humanDateToComputedDate(value);

      return delivered_or_cancelled_at
        ? {
            delivered_or_cancelled_at,
          }
        : null;
    },
    route(value) {
      if (!value) {
        return null;
      }

      if (value === 'longhaul') {
        return {
          long_haul: true,
        };
      }

      // This las join is a shit, a big shit.
      return {
        route: value
          .split(',')
          .map((route) =>
            route
              .split('-')
              .map((end) => end)
              .join('->')
          )
          .join('&route='),
      };
    },
    no_cargo_manifest(value) {
      if (!value) {
        return null;
      }

      return {
        has_cargo_manifest: String(!value),
      };
    },
    shipper: valueOrUndefined('shipper'),
    carrier: valueOrUndefined('carrier'),
    driver: valueOrUndefined('driver'),
  };

  return Object.keys(query)
    .map((f) => {
      return convert[f] ? convert[f](query[f]) : null;
    })
    .filter((filter) => filter);
};

export const urlOrMe = (obj) => (obj && typeof obj === 'object' ? obj.url : obj);

export const splitHours = (v) => {
  const value = v.split(':');
  return {
    hours: value[0],
    minutes: value[1],
  };
};

export { normalize, objectize, urlToId };
